export default "__VITE_ASSET__PafN$r2S__"